import { RESET_PASSWORD_KEY, STEPPER_FORM_DATA_KEY } from '../constants/stepperFormDataKey'

interface UBO {
  firstName: string
  lastName: string
  companyEmail: string
  executingTrades: boolean
}

// eslint-disable-next-line
interface DefaultValues {
  ubo: UBO[]
}

// eslint-disable-next-line
export const getStepperFormData = (): any => {
  const rawFormData = sessionStorage.getItem(STEPPER_FORM_DATA_KEY)

  if (!rawFormData) {
    return {}
  }
  return JSON.parse(rawFormData)
}

// eslint-disable-next-line
export const getUserForResetPassword = (): any => {
  const rawForResetPassData = sessionStorage.getItem(RESET_PASSWORD_KEY)

  if (!rawForResetPassData) {
    return {
      firstName: '',
      lastName: '',
      email: '',
      password: '',
      confirmPassword: '',
    }
  }
  return JSON.parse(rawForResetPassData)
}
